import { type globals } from './@types/globals'

import MobileDetect from 'mobile-detect'

import currencies from './data/currencies.json' with { type: 'json' }; 
import countries from './data/countries.json'
import icons from './data/bootstrap-icons.json' 

const locales = helpers.getCookie('lang') || (new Intl.NumberFormat()).resolvedOptions().locale

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
//const md = new MobileDetect(window.navigator.userAgent)

export const vars : globals = {
    locales: typeof locales === "undefined" || locales == null ? 'en' : locales,
    timeZone: typeof timeZone === "undefined" || timeZone == null ? 'Etc/UTC' : timeZone,
    
    theme: $('html').attr("data-bs-theme") || 'dark',
    //isMobileDevice: md.mobile() !== null ? true : false,

    settings: {},

    userPreferences: {},

    currencies: currencies,

    dataTable_transactions: undefined,

    countries: countries,

    userData: {
        accounts: [],
        accountsById: [],
        settings: {},
        categories: [],
        categoriesById: []
    },

    icons: icons,

    privacyMode: false,

    charts: {}
}

